module.exports = __webpack_public_path__ + "img/chair-office.e22cd572.svg";